<template>
  <div class="h-100">
   
        <component v-bind:is="layout"/>
    
  </div>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import BaseLayout from './layouts/BaseLayout'
import DashboardLayout from './layouts/DashboardLayout'

export default {
  computed: {
    layout () {
      return this.$store.getters['app/layout']
    }
  },
  components: {
    'app-layout': AppLayout,
    'base-layout': BaseLayout,
    'dashboard-layout': DashboardLayout
  },
 
}
</script>
